import { App } from 'vue';
import Button from './src/button.vue';

Button.install = (app: App): void => {
    app.component(Button.name, Button);
};

export default Button;

declare module 'vue' {
    export interface GlobalComponents {
        PtButtonV2: typeof Button;
    }
}
